/**
 * Converte entrada monetária do usuário em número, aceitando formato
 * brasileiro ("1.234,56" ou "1234,56") e formato com ponto ("1234.56").
 * Retorna 0 para valores vazios/ inválidos.
 */
export function parseDecimalBR(v) {
  if (typeof v === 'number') return Number.isFinite(v) ? v : 0;
  if (v === null || v === undefined) return 0;
  let s = String(v).trim();
  if (!s) return 0;
  if (s.includes(',')) {
    // Formato BR: pontos são separadores de milhar, vírgula é decimal.
    s = s.replace(/\./g, '').replace(',', '.');
  }
  const n = parseFloat(s);
  return Number.isFinite(n) ? n : 0;
}

/**
 * Formata um valor digitado para exibição monetária pt-BR com SEMPRE 2 casas
 * decimais ("10000" → "10.000,00"). Retorna '' para vazio/zero — assim campos
 * opcionais não viram "0,00" sozinhos.
 */
export function formatDecimalBR(v) {
  const n = parseDecimalBR(v);
  if (!n) return '';
  return n.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

/**
 * Máscara monetária "ao vivo" (enquanto digita): mantém apenas dígitos e uma
 * vírgula, limita a 2 casas decimais e insere os pontos de milhar na parte
 * inteira ("10000" → "10.000"; "10000,5" → "10.000,5"). O blur completa as
 * casas decimais via formatDecimalBR. Não muda o valor — só a exibição.
 */
export function mascaraDecimalBR(v) {
  let s = String(v ?? '').replace(/[^\d,]/g, '');
  if (!s) return '';
  const i = s.indexOf(',');
  let int = i >= 0 ? s.slice(0, i) : s;
  let dec = i >= 0 ? s.slice(i + 1).replace(/,/g, '').slice(0, 2) : null;
  int = int.replace(/^0+(?=\d)/, '');
  int = int.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return dec === null ? int : `${int},${dec}`;
}

/**
 * Máscara monetária estilo "caixa eletrônico": o campo SEMPRE exibe um valor
 * válido ("0,00" por padrão), letras são descartadas e cada dígito digitado
 * entra pelos centavos ("0,00" + 1 → "0,01"; + 00 → "1,00"; + 23 → "100,23").
 * Idempotente: mascaraMoedaBR("100,23") === "100,23".
 */
export function mascaraMoedaBR(v) {
  const d = String(v ?? '').replace(/\D/g, '').replace(/^0+(?=\d)/, '').slice(0, 15);
  const cents = d.padStart(3, '0');
  const int = cents.slice(0, -2).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${int},${cents.slice(-2)}`;
}

export default parseDecimalBR;
